<!-- eslint-disable vue/no-v-html -->
<template>
    <div class="onboarding-step onboarding-step-base">
        <p
            class="error"
            v-html="error"
        />
    </div>
</template>

<script>
export default {
    props: {
        error: {
            type: String,
            default: 'Something went wrong. Please try again or <a href="mailto:help@fusebox.fm">contact us</a>',
        },
    },
};
</script>
